module.exports = __webpack_public_path__ + "static/img/news19_1.1cc2507.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/news19_1.jpeg
// module id = r7PH
// module chunks = 0